// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3JhER","selects":"Documents_selects__3t_JL"};